import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function FuelConsumption({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Fuel Consumption"
      fullCaption="Differential Mass Flow.NAN gram/s..
      Differential Zero.......0.0f.gram/s.......
      ............................................................
      ............................................................
      ............................................................
      ............................................................
      "
    />
  );
}

export default FuelConsumption;
